module.exports = __webpack_public_path__ + "img/download.09fc2531.svg";